import styled from "styled-components/macro";

export const PromoCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  background-color: var(--menu-color-fullscreen);
  box-shadow: var(--card-drop-shadow);
  border-radius: 12px;
  padding: 24px;
  position: relative;

  &.outlined {
    &:before {
      content: "";
      position: absolute;
      top: -8px;
      left: -8px;
      right: -8px;
      bottom: -8px;
      background: radial-gradient(circle at top left, var(--primary-cta) 0%, var(--primary-cta-transparent-15) 70%);
      z-index: -1;
      border-radius: 18px;
      outline: 1px solid var(--primary-cta-transparent-30);
    }

    &:after {
      content: "";
      position: absolute;
      top: -12px;
      left: -12px;
      right: -12px;
      bottom: -12px;
      background: radial-gradient(circle at top left, var(--primary-cta) 0%, transparent 70%);
      filter: brightness(2.75) blur(12px) opacity(0.5);
      z-index: -2;
      border-radius: 18px;
    }
  }

  .close {
    align-self: flex-end;
    margin-top: -16px;
    margin-right: -16px;
    cursor: pointer;

    width: 16px;
    height: 16px;

    path {
      fill: var(--grey-2);
    }
  }

  .resources-title {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;
    justify-content: center;
    margin-bottom: auto;
    margin-top: auto;

    .resources-title-new {
      font-family: "GT Super Text";
      font-weight: 500;
      font-size: 15px;
      letter-spacing: 1.5px;
      text-transform: uppercase;
      color: var(--primary-cta-high-contrast);
    }

    .resources-title-icon {
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        path {
          fill: var(--primary-cta);
        }
      }
    }

    .resources-title-text {
      font-family: "GT Super Text";
      font-weight: 400;
      font-size: 28px;
      color: var(--grey-0);
      text-align: center;
      line-height: 110%;
    }
  }

  .resources-description {
    text-align: center;
    width: 177px;
    line-height: 1.3;
    font-family: "Inter";
    font-weight: 500;
    font-size: 14px;
    color: var(--grey-1);
    margin-top: 21px;
  }

  .resources-container {
    display: flex;
    flex-direction: column;
    gap: 5px;

    .resource {
      font-family: "Inter";
      font-weight: 500;
      font-size: 13px;
      color: var(--grey-0);

      text-align: center;
      border-radius: 8px;
      padding: 10px;
      box-shadow: 0px 0px 3.24px 0px rgba(0, 0, 0, 0.2);

      &:hover {
        background-color: var(--container-color);
      }
    }
  }
`;
